import React from 'react';


import {
  StdIconsRight,
  BTIcon,


} from './style';

import { dispatchData } from '@/helpers/dispatchData';

import { useSelector, useDispatch } from 'react-redux';
import { openChat } from '@/Redux/slices/chatSlice';
import { postServer } from '@/helpers/newFunctions'
const pagesNoSearch = ['welcome'];

const iconMenuHome = ({ pageSelected }) => {
  const dispatch = useDispatch()
  const logout = async () => {
    const result = await postServer('auth/logout'); // precisa do await
    if (result?.status) {  // checa se veio { status: true }
      window.location.replace(process.env.URL_SITE);
    }
  }

  return (
    <>

      <StdIconsRight >
        <BTIcon onClick={() => dispatch(openChat())} >
          <svg
            width="24" height="24" viewBox="0 0 24 24"
            fill="currentColor">
            <path fillRule="evenodd" d="M22.67 5.635a3.662 3.662 0 1 1-7.323 0 3.662 3.662 0 0 1 7.323 0m1.33 0a4.992 4.992 0 1 1-9.983 0 4.992 4.992 0 0 1 9.983 0m-5.648.006v2.474h1.33V5.641zm1.39-1.678a.733.733 0 1 1-1.466 0 .733.733 0 0 1 1.465 0Zm-10.155 9.19c1.652 0 2.91-1.135 2.91-2.91 0-1.774-1.258-2.91-2.91-2.91-1.651 0-2.91 1.136-2.91 2.91s1.259 2.91 2.91 2.91m0 1.33c2.342 0 4.24-1.687 4.24-4.24s-1.898-4.24-4.24-4.24c-2.341 0-4.24 1.688-4.24 4.24s1.899 4.24 4.24 4.24m-.664 1.98v-1.13h1.33v1.13zm0 1.413v3.854c-2.3-.02-5.23-.127-6.581-.18l.563-3.775c.066-.443.35-.823.755-1.013l2.39-1.115-.563-1.205-2.389 1.115a2.67 2.67 0 0 0-1.509 2.022L1 21.536a1.16 1.16 0 0 0 1.1 1.334c1.365.056 4.985.192 7.488.192 2.516 0 6.135-.136 7.493-.192a1.16 1.16 0 0 0 1.103-1.323l-.55-3.943a2.67 2.67 0 0 0-1.523-2.052l-2.414-1.113-.557 1.208 2.414 1.113c.412.19.7.578.763 1.028l.524 3.761c-1.346.054-4.279.162-6.589.18v-3.853z" clipRule="evenodd"></path>
          </svg>
        </BTIcon>
        {!pagesNoSearch.includes(pageSelected) &&
          <BTIcon onClick={() => dispatchData('openGlobalSearch')}>
            <svg width="24px" height="24px"
              viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
              <path
                d="M22.771 21.601l-5.591-5.979a9.06 9.06 0 001.837-5.624 8.723 8.723 0 00-9-9 8.699 8.699 0 00-9 9 8.69 8.69 0 009 9 9.18 9.18 0 005.764-1.944l5.53 5.913zm-12.754-4.603a6.697 6.697 0 01-7-7 6.697 6.697 0 017-7 6.697 6.697 0 017 7 6.697 6.697 0 01-7 7z">
              </path>
            </svg>
          </BTIcon>
        }
        <BTIcon onClick={logout} >
          <svg
            width="24" height="24" viewBox="0 0 24 24"
            fill="currentColor">
            <path
              d="M11.72 3.004C6.61 3.134 3 6.836 3 12c0 5.257 3.743 9 9 9s9-3.743 9-9c0-5.164-3.61-8.866-8.72-8.996L12 3zm.582-2C18.508 1.147 23 5.738 23 12c0 6.362-4.638 11-11 11S1 18.362 1 12C1 5.739 5.492 1.148 11.698 1.003L12 1l.302.003z">
            </path>
            <path
              d="M11.825 7.005C10.439 7.082 9.5 8.078 9.5 9.5c0 1.481 1.019 2.5 2.5 2.5s2.5-1.019 2.5-2.5c0-1.422-.939-2.418-2.325-2.495L12 7zm.395-2c2.474.105 4.28 1.983 4.28 4.495 0 2.586-1.914 4.5-4.5 4.5s-4.5-1.914-4.5-4.5c0-2.512 1.807-4.39 4.28-4.495L12 5zM8.936 14.113l.784 1.84-1.332.562-.495.217-.279.128c-1.209.567-1.676.985-1.786 1.54l-.077.397-.077.41-1.967-.361.16-.836c.266-1.342 1.168-2.149 2.898-2.96l.368-.169.926-.398zM14.47 14.113l-.784 1.84 1.51.64.46.204.136.063c1.209.567 1.676.985 1.786 1.54l.154.807 1.967-.361a60 60 0 0 0-.159-.836c-.266-1.342-1.168-2.149-2.898-2.96l-.368-.169-.425-.186z">
            </path>
          </svg>
        </BTIcon>

        {/* <DivText>
          <BTIcon >
            <svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M3 10.3c0 5 7.4 12.7 9 12.7s9-7.8 9-12.7S17.3 2 12 2s-9 3.3-9 8.3m2 0C5 6 8.5 4 12 4s7 2.5 7 6.3-5.4 9.5-7 10.6c-1.6-1.1-7-6.3-7-10.6m4-.3c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3m2 0c0-.6.4-1 1-1 .5 0 1 .3 1 1s-.5 1-1 1-1-.4-1-1">
              </path>
            </svg>
            <TextIcon>Nome do user</TextIcon>
          </BTIcon>
        </DivText> */}
      </StdIconsRight>
    </>
  );
};

export default iconMenuHome;
